import { getBrowserLocales } from 'services/getBrowserLocales';
import { SUPPORTED_LOCALES } from './currency';

const formatPrice = (price: string | number, options?) => {
  const browserLocales = getBrowserLocales();

  const locale =
    !!browserLocales?.[0] && SUPPORTED_LOCALES.includes(browserLocales?.[0])
      ? browserLocales?.[0]
      : 'en-US';

  const value = typeof price === 'string' ? parseFloat(price) : price;

  return Number.isFinite(value)
    ? value.toLocaleString(locale, { style: 'currency', currency: 'USD', ...options })
    : '-';
};

export default formatPrice;
